import { FC } from 'react';
import { useUserInfoIsUserAllowedAction } from '../../../../userProfile/src/contexts/UserInfo/hooks';

type EntitlementRestrictionProps = {
  requiredEntitlements?: string | string[];
  logic?: 'OR' | 'AND';
};

const EntitlementRestriction: FC<EntitlementRestrictionProps> = ({ requiredEntitlements, logic, children }) => {
  const isAllowed = useUserInfoIsUserAllowedAction(requiredEntitlements, logic);
  if (!isAllowed) {
    return null;
  }

  return children as any;
};
export { EntitlementRestriction };
